export const WAIT_COLOR = {
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
  GRAY: 'gray'
}

const SECONDS_PER_MINUTE = 60
const MINUTES_PER_HOUR = 60
export const ORANGE_FROM_MINUTE = 10
export const WAIT_TOLERANCE_MINUTES = 16
const RED_FROM_MINUTE = WAIT_TOLERANCE_MINUTES
const EMPTY_WAIT = '--:--'
const PAD_LENGTH = 2
const PAD_CHAR = '0'
const CLOCK_TIME_LENGTH = 5

export function formatWait (seconds) {
  if (seconds === null || seconds === undefined) {
    return EMPTY_WAIT
  }

  const totalSeconds = Math.max(0, Math.floor(seconds))
  const totalMinutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE)
  const secondsPart = pad(totalSeconds % SECONDS_PER_MINUTE)

  if (totalMinutes < MINUTES_PER_HOUR) {
    return pad(totalMinutes) + ':' + secondsPart
  }

  return Math.floor(totalMinutes / MINUTES_PER_HOUR) + ':' + pad(totalMinutes % MINUTES_PER_HOUR) + ':' + secondsPart
}

export function roundedMinutes (seconds) {
  return Math.round(seconds / SECONDS_PER_MINUTE)
}

export function shortClockTime (time) {
  return time ? time.substr(0, CLOCK_TIME_LENGTH) : ''
}

export function waitColor (seconds) {
  if (seconds === null || seconds === undefined) {
    return WAIT_COLOR.GRAY
  }

  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE)

  if (minutes >= RED_FROM_MINUTE) {
    return WAIT_COLOR.RED
  }
  if (minutes >= ORANGE_FROM_MINUTE) {
    return WAIT_COLOR.ORANGE
  }

  return WAIT_COLOR.GREEN
}

export function crossedIntoOrange (previousSeconds, nextSeconds) {
  return waitColor(previousSeconds) === WAIT_COLOR.GREEN &&
    waitColor(nextSeconds) === WAIT_COLOR.ORANGE
}

function pad (value) {
  return String(value).padStart(PAD_LENGTH, PAD_CHAR)
}
